import { Text } from '@mantine/core';
import { CSSProperties, ReactElement, ReactNode } from 'react';
import { ORBIT_DISABLED } from '@/theme/colors';

/** A one-line ledger cell: 13/18, truncated, the full value on hover when `title` is set. */
export function LedgerCell({
  children,
  color,
  weight,
  title,
  style,
}: {
  children: ReactNode;
  color?: string;
  weight?: number;
  title?: string;
  style?: CSSProperties;
}): ReactElement {
  return (
    <Text fz={13} lh="18px" c={color ?? 'black'} fw={weight} title={title} truncate style={{ width: '100%', ...style }}>
      {children}
    </Text>
  );
}

export function LedgerEmptyCell(): ReactElement {
  return <LedgerCell color={ORBIT_DISABLED}>—</LedgerCell>;
}
